import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import LanguageSwitcher from 'components/LanguageSwitcher';
import { useI18n } from 'i18n/I18nContext';

const SiteFooter = () => {
  const { t } = useI18n();

  return (
    <footer id="gb-site-footer" className="gb-site-footer">
      <div className="gb-site-footer__inner container">
        <div className="gb-site-footer__top">
          <p className="gb-site-footer__brand m-0">
            {t('footer.copyright', { year: String(new Date().getFullYear()) })}
          </p>
          <LanguageSwitcher variant="onDark" className="gb-site-footer__lang" />
        </div>

        <nav className="gb-site-footer__nav" aria-label={t('footer.nav')}>
          <LocalizedLink className="gb-site-footer__link" to="/for">
            {t('footer.forVenues')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/guides">
            {t('footer.guides')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/compare">
            {t('footer.compare')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/checklist">
            {t('footer.checklist')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/pricing">
            {t('footer.pricing')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/terms">
            {t('footer.terms')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/privacy">
            {t('footer.privacy')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/cookies">
            {t('footer.cookies')}
          </LocalizedLink>
          <LocalizedLink className="gb-site-footer__link" to="/contact">
            {t('footer.contact')}
          </LocalizedLink>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;



// WEBPACK FOOTER //
// ./src/components/SiteFooter.tsx